// app/javascript/controllers/auto_submit_controller.js
import { Controller } from "@hotwired/stimulus"

// Usage:
// <form data-controller="auto-submit">
//   <select data-action="change->auto-submit#submit">...</select>
// </form>
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
